import { FC } from 'react'
import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import { MediaCardSkeleton } from '@shared/ui/Layout/Cards/MediaCard'

interface Props {
  className?: string
  sizes: string
}

const Skeleton: FC<Props> = (props) => {
  return (
    <BlockBoundary>
      <MediaCardSkeleton {...props} />
    </BlockBoundary>
  )
}

export default Skeleton
